import {
  USERS,
  USER,
  POOLS,
  BILLING_USER_POOLS,
  CATEGORY,
  PRODUCTS,
  PRODUCT,
  ADMIN_PAYMENT_INFOS,
  CORPORATIONS,
  CORPORATION,
  ORDER,
  BROADCAST_EMAILS,
  BROADCAST_EMAIL,
  GROUPS,
  GROUP,
  POOL,
  POOL_HOLDERS,
  SIGNUPS,
  BUSINESS_UNITS,
  BUSINESS_UNIT,
  ACTIVE_FEATURE_FLAG,
  CAMPAIGN_TRIGGERS,
  CAMPAIGN_TRIGGER,
  FEATURE_FLAGS,
  COMRA_REPORTS,
  OFFICE_LOCATIONS,
  OFFICE_LOCATION,
  EMAIL_TEMPLATE_QUEUE,
  EMAIL_TEMPLATE_QUEUE_ENTRY,
  SAVE_AGENCY_USERS,
  CLEAR_AGENCY_USERS
} from '@/store/actions/admin/users.actions';

const initialState = {
  users: [],
  user: {},
  metadata: {},
  pools: [],
  billing_user_pools: [],
  pool: {},
  pool_holders: [],
  category: {},
  products: [],
  products_meta: {},
  product: {},
  payment_infos: [],
  payment_infos_meta: {},
  corporations: [],
  corporation: {},
  order: {},
  broadcast_emails: [],
  broadcast_emails_meta: {},
  broadcast_email: {},
  groups: [],
  group: {},
  business_units: [],
  business_unit: {},
  active_feature_flag: '',
  feature_flags: [],
  signups: [],
  signups_meta: {},
  campaign_triggers: [],
  campaign_triggers_meta: {},
  campaign_trigger: {},
  comra_reports: [],
  comra_reports_meta: {},
  office_locations: [],
  office_locations_meta: {},
  office_location: {},
  email_template_queue: [],
  email_template_queue_meta: {},
  email_template_queue_entry: {},
  agency_users: []
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case USERS:
      return {
        ...state,
        users: action.payload.data,
        metadata: action.payload.meta
      };
    case USER:
      return {
        ...state,
        user: action.payload.data
      };
    case POOLS:
      return {
        ...state,
        pools: action.payload.data
      };
    case BILLING_USER_POOLS:
      return {
        ...state,
        billing_user_pools: action.payload.data
      };
    case CATEGORY:
      return {
        ...state,
        category: action.payload.data
      };
    case PRODUCTS:
      return {
        ...state,
        products: action.payload.data,
        products_meta: action.payload.meta
      };
    case PRODUCT:
      return {
        ...state,
        product: action.payload.data
      };
    case ADMIN_PAYMENT_INFOS:
      return {
        ...state,
        payment_infos: action.payload.data,
        payment_infos_meta: action.payload.meta
      };
    case CORPORATIONS:
      return {
        ...state,
        corporations: action.payload.data
      };
    case CORPORATION:
      return {
        ...state,
        corporation: action.payload.data
      };
    case ORDER:
      return {
        ...state,
        order: action.payload.data
      };
    case BROADCAST_EMAILS:
      return {
        ...state,
        broadcast_emails: action.payload.data || [],
        broadcast_emails_meta: action.payload.meta || {}
      };
    case BROADCAST_EMAIL:
      return {
        ...state,
        broadcast_email: action.payload.data
      };
    case GROUPS:
      return {
        ...state,
        groups: action.payload.data
      };
    case GROUP:
      return {
        ...state,
        group: action.payload.data
      };
    case POOL:
      return {
        ...state,
        pool: action.payload.data
      };
    case POOL_HOLDERS:
      return {
        ...state,
        pool_holders: action.payload.data
      };
    case BUSINESS_UNITS:
      return {
        ...state,
        business_units: action.payload.data
      };
    case BUSINESS_UNIT:
      return {
        ...state,
        business_unit: action.payload.data
      };
    case ACTIVE_FEATURE_FLAG:
      return {
        ...state,
        active_feature_flag: action.payload?.data
      };
    case SIGNUPS:
      return {
        ...state,
        signups: action.payload.data,
        signups_meta: action.payload.meta
      };
    case CAMPAIGN_TRIGGERS:
      return {
        ...state,
        campaign_triggers: action.payload.data,
        campaign_triggers_meta: action.payload.meta
      };
    case CAMPAIGN_TRIGGER:
      return {
        ...state,
        campaign_trigger: action.payload.data
      };
    case FEATURE_FLAGS:
      return {
        ...state,
        feature_flags: action.payload.data
      };
    case COMRA_REPORTS:
      return {
        ...state,
        comra_reports: action.payload.data,
        comra_reports_meta: action.payload.meta
      };
    case OFFICE_LOCATIONS:
      return {
        ...state,
        office_locations: action.payload.data,
        office_locations_meta: action.payload.meta
      };
    case OFFICE_LOCATION:
      return {
        ...state,
        office_location: action.payload.data
      };
    case EMAIL_TEMPLATE_QUEUE:
      return {
        ...state,
        email_template_queue: action.payload.data || [],
        email_template_queue_meta: action.payload.meta || {}
      };
    case EMAIL_TEMPLATE_QUEUE_ENTRY:
      return {
        ...state,
        email_template_queue_entry: action.payload.data || {}
      };
    case SAVE_AGENCY_USERS:
      return { ...state, agency_users: action.payload };
    case CLEAR_AGENCY_USERS:
      return { ...state, agency_users: [] };
    default:
      return state;
  }
}
